module.exports = __webpack_public_path__ + "img/CNReport.d0f60730.png";